export const getLocationFilterStyle = () => ({
  locationFilterDowndown: {
    padding: 24,
    pointerEvents: 'auto',
  },

  dropdownTitle: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '20px',
  },

  dropdownLocationChoice: {
    '& label': {
      fontSize: 14,
      fontWeight: 400,
      padding: 0,
      marginTop: 8,
    },
  },
});
